import React, { useState } from 'react';
import ConversationHeader from 'components/molecules/smsDashboard/conversationHeader';
import ConversationsList from 'components/molecules/smsDashboard/conversationsList';
import ConversationTabs from 'components/molecules/smsDashboard/conversationTabs';

import s from './styles.module.scss';
import ConversationStatusFilter from '../conversation-status-filter';

interface IConversationsProps {
  setScrollToMessage: React.Dispatch<React.SetStateAction<any>>;
}

const Conversations: React.FC<IConversationsProps> = (props) => {
  const { setScrollToMessage } = props;
  const [selectMode, setSelectMode] = useState<boolean>(false);
  const [checkedConversations, setCheckedConversations] = useState<number[]>(
    [],
  );
  const [searchText, setSearchText] = useState<string>('');

  return (
    <div className={s.conversations}>
      <ConversationStatusFilter />
      <ConversationTabs
        setSelectMode={setSelectMode}
        setCheckedConversations={setCheckedConversations}
        setSearchText={setSearchText}
      />
      <ConversationHeader
        setSelectMode={setSelectMode}
        selectMode={selectMode}
        checkedConversations={checkedConversations}
        setCheckedConversations={setCheckedConversations}
        setScrollToMessage={setScrollToMessage}
        setSearchText={setSearchText}
        searchText={searchText}
      />
      <ConversationsList
        selectMode={selectMode}
        checkedConversations={checkedConversations}
        setCheckedConversations={setCheckedConversations}
        setScrollToMessage={setScrollToMessage}
      />
    </div>
  );
};

export default Conversations;
